import React from 'react';
import { connect } from 'react-redux';
//import 'antd/dist/antd.css';
import { Collapse } from 'antd';
import { Checkbox } from 'antd';
import { LoadingComponent } from '../../utils/ui'
import { AdmsRepository } from '../../redux/AdmsActions';
import { subsetByLang, subsetByLangOrEmpty } from '../../virtuoso/helper';
import ConceptCount from '../widgets/ConceptCount';
const Panel = Collapse.Panel;

function callback(key) {
  console.log(key);
}
/** Отображение схемы концептов (ConceptScheme в SKOS). Схема концептов определяется по IRI. Для схемы:
 * 1. загружается имя схемы
 * 2. загружается состав концептов (концепты, которые имеют свойство http://www.w3.org/2004/02/skos/core#inScheme)
 * 3. загружается количество концептов
*/
class ConceptScheme extends React.Component {	
  state = {
    loading: true, 			//Флаг загрузки
  }

  componentWillMount() { 
    this.loadTaxonomy();
  }

  componentWillReceiveProps(nextProps){
    const {content} = nextProps;
    if ((content==undefined)||(content.state==undefined)||content.state=="empty")
      this.loadTaxonomy();
  }

  loadTaxonomy() {
    this.setState({loading: true})
    const {IRI} = this.props;
    if (IRI)
      this.props.dispatch(AdmsRepository.loadTaxonomy(IRI))
      .then ((response) =>{
        this.setState({loading: false})
			})
			.catch(e => { 
        this.setState({loading: false})
			});
  }
    
  onChangeConcept(e, concept) {
    //console.log(`checked = ${e.target.checked}`, e, concept, this);
    const {onChange, IRI} = this.props;
    const condition = {
      predicate: "http://www.w3.org/ns/dcat#theme", 
      operator: "=", 
      value: concept.IRI.value, 
      alias:"theme", 
      label:concept.Label.value,
      type: "uri",
      scheme: IRI
    };
    if (onChange) onChange(e.target.checked, condition);
  }

  render() {
    const {loading} = this.state
    const {IRI, content, lang, selected} = this.props;
    const headers = (!loading && content && content.schema)? subsetByLang(content.schema, lang, "label"):[];
    const concepts = (!loading && content && content.concepts)? subsetByLangOrEmpty(content.concepts, lang, "IRI", "Label"):[];
    const header = (Array.isArray(headers)&&(headers.length>0))? headers[0].label.value: IRI;
    //console.log(this); console.log(loading); console.log(JSON.stringify(content));
    //Формируем отображение название схемы и список элементов в схеме
    return (
      <Collapse onChange={callback}>
      <Panel header={header}>
          {loading && <LoadingComponent />}
          {concepts.map((concept, i)=> {
            const isChecked = (selected)? selected.filter(
                item => (Array.isArray(item.value)?item.value.indexOf(concept.IRI.value)>=0:item.value==concept.IRI.value)
              ).length>0: false;
            //console.log("concepts.map((concept, i)",isChecked, concept);
            return (
              <p key={i}>
                <Checkbox checked={isChecked} onChange={(e) => this.onChangeConcept(e, concept)}>
                  {concept.Label.value}&nbsp;<ConceptCount IRI={concept.IRI.value}/>
                </Checkbox>
              </p>
            )
          })}
          {(!loading && (concepts.length==0)) && <p>Нет связанных концептов.</p>}
      </Panel>
      </Collapse>
    )
  }
}

function mapStateToProps(state, props) {
  //Значения в store redux
  const {vadms, vset} = state;
  const {lang, graph, schema, IRI} = props;
  const rIRI = (IRI)?IRI: (schema && schema.IRI)? schema.IRI.value: "IRI схемы не задан";
  const content = (schema)?[schema]:(vadms.taxonomy)? vadms.taxonomy.filter(item => item.IRI.value==IRI):[];
  return {
      lang: (lang)?lang: vset.lang,
      graph: (graph)?graph: vset.graph,
      IRI: rIRI,
      content: (Array.isArray(content)&& content.length>0)? content[0]: undefined,
      selected: vadms.conditions,
  };
}

export default connect(mapStateToProps)(ConceptScheme);